import React from 'react';
import './SingleCameraNotice.css';

const SingleCameraNotice: React.FC = () => {
  return (
    <div className="single-camera-notice">
      <div className="notice-icon">📹</div>
      <div className="notice-content">
        <strong>Single-Camera Analysis</strong>
        <p>
          This analysis is based on a single camera (2D pose). Some metrics are approximations. 
          Hip rotation is a 2D proxy; foot speed depends on calibration.
        </p>
      </div>
    </div>
  );
};

export default SingleCameraNotice;






